import React, { useEffect, useState } from 'react';
import FunctionSidebarContainer from "../common/FunctionSidebar/FunctionSidebarContainer";
import Button from "@material-ui/core/Button";
import { themeButtons } from "../../css/themeButtons";
import Modal from "../common/Modals/Modal";
import { Field, Form, Formik } from "formik";
import TextField from "@material-ui/core/TextField";
import { FormControl, GreenCheckbox } from "../ObjectServices/styles";
import * as Yup from "yup";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GreenRadio } from "./styles";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import { CustomTooltip } from "../CalendarPercent/styles";
import Preloader from "../common/Preloader/Preloader";
import { usePrevious } from "../common/CustomHook/usePrevious";
import { useUserRole } from "../../App";
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import { makeStyles } from "@material-ui/styles";
import { phoneRegExp } from "../../utils/phoneValidate";

const useStyles = makeStyles((theme) => ({
  snackbar: {
    bottom: "60px",
    borderRadius: ".25rem",
  },

}));

//рендер строки с контактом (телефон)
export const RenderPhoneListItem = ({
  showChangeModal,
  showDeleteModal,
  id,
  owner,
  phone,
  name,
  messenger,
  phoneMain,
  ownerList,
  type,
  replacementImportantContact,
  position
}) => {

  const userRole = useUserRole()


  const messengerSwitch = (item) => {
    switch (item) {
      case "WHATSAPP": {
        return <div key={item} className="wa"><FontAwesomeIcon icon={["fab", "whatsapp"]}/> WhatsApp</div>
      }
      case "VIBER": {
        return <div key={item} className="vb"><FontAwesomeIcon icon={["fab", "viber"]}/> Viber</div>
      }
    }

  }

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (type, newContactId) => {
    replacementImportantContact(type, "phones", newContactId, id)
    setAnchorEl(null);
  };

  let changeMenuItems = []
  if (ownerList) {
    ownerList.forEach(contact =>
      phone !== contact.phone && changeMenuItems.push(<MenuItem key={contact.id}
                                                                onClick={() => handleClose(type, contact.id)}>{contact.phone}</MenuItem>)
    )
  }

  return (
    <div className="contacts-list__row ">
      <div className="contacts-list__item info me-auto">
        <div className="item__phone-name">
          <div className="name">
            {name}{name && position && userRole === "MODERATOR" && " - "}{userRole === "MODERATOR" && position}
          </div>
          <div className="phone">
            {phone}{phoneMain === "Y" &&
            <FontAwesomeIcon icon={"check-circle"} className="text-success ms-1"/>}
          </div>
        </div>
        <div className="contacts-list__item item__messangers">
          {messenger && messenger.map(item => {
            return messengerSwitch(item)
          })}
        </div>
      </div>

      <div className="contacts-list__item item__btns">
        {!owner && <>
          <CustomTooltip title={'Этот контакт можно заменить на любой из блока "Контакты объекта размещения"'}
                         arrow placement="top">
                       <span> <Button className="btn px-2" disabled={changeMenuItems.length === 0}
                                      onClick={handleClick}><FontAwesomeIcon
                         icon={["fas", "sync-alt"]}
                         className="me-1"/> Заменить
                        </Button></span>
          </CustomTooltip>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => handleClose()}
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            {changeMenuItems}


          </Menu>
        </>}

        {owner && <>
          <Button className="btn px-2" onClick={showChangeModal}><FontAwesomeIcon icon={["far", "edit"]}
                                                                                  className="me-1"/> Изменить
          </Button>
          <Button className="btn px-2 text-danger" onClick={showDeleteModal}><FontAwesomeIcon icon={"trash"}
                                                                                              className="me-1"/> Удалить
          </Button>
        </>}


      </div>
    </div>
  )
}

//рендер строки с контактом (почта)
export const RenderMailListItem = ({
  showChangeModal,
  showDeleteModal,
  id,
  owner,
  email,
  mailMain,
  ownerList,
  type,
  replacementImportantContact,
  position
}) => {
  const userRole = useUserRole()

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (type, newContactId) => {
    replacementImportantContact(type, "mails", newContactId, id)
    setAnchorEl(null);
  };

  let changeMenuItems = []
  if (ownerList) {
    ownerList.forEach(contact =>
      email !== contact.email && changeMenuItems.push(<MenuItem key={contact.id}
                                                                onClick={() => handleClose(type, contact.id)}>{contact.email}</MenuItem>)
    )
  }


  return (
    <div className="contacts-list__row ">
      <div className="contacts-list__item item__mail  me-auto">
        {userRole === "MODERATOR" && <span className="name">{position}</span>}
        <span>{email}{mailMain === "Y" &&
          <FontAwesomeIcon icon={"check-circle"} className="text-success ms-1"/>}</span>

      </div>


      <div className="contacts-list__item item__btns">
        {!owner && <>
          <CustomTooltip title={'Этот контакт можно заменить на любой из блока "Контакты объекта размещения"'}
                         arrow placement="top">
                        <span><Button className="btn px-2" disabled={changeMenuItems.length === 0}
                                      onClick={handleClick}><FontAwesomeIcon
                          icon={["fas", "sync-alt"]}
                          className="me-1"/> Заменить
                        </Button></span>
          </CustomTooltip>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => handleClose()}
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            {changeMenuItems}


          </Menu>
        </>}


        {owner && <>
          <Button className="btn px-2" onClick={showChangeModal}><FontAwesomeIcon icon={["far", "edit"]}
                                                                                  className="me-1"/> Изменить
          </Button>
          <Button className="btn px-2 text-danger" onClick={showDeleteModal}><FontAwesomeIcon icon={"trash"}
                                                                                              className="me-1"/> Удалить
          </Button>
        </>}

      </div>
    </div>
  )
}

//рендер блока с контактами
export const RenderPhoneBlock = ({
  type,
  title,
  lists,
  toggleShow,
  ownerList,
  replacementImportantContact,
  paymentType
}) => {


  const [changeMenuPhones, setChangeMenuPhones] = useState();
  const [changeMenuMails, setChangeMenuMails] = useState();

  const [anchorElPhones, setAnchorElPhones] = useState(null);
  const handleClickPhones = (event) => {
    setAnchorElPhones(event.currentTarget);
  };

  const handleClosePhones = (type, newContactId) => {
    replacementImportantContact(type, "phones", newContactId)
    setAnchorElPhones(null);
  };


  const [anchorElMails, setAnchorElMails] = useState(null);
  const handleClickMails = (event) => {
    setAnchorElMails(event.currentTarget);
  };

  const handleCloseMails = (type, newContactId) => {
    replacementImportantContact(type, "mails", newContactId)
    setAnchorElMails(null);
  };


  const prevOwnerList = usePrevious(JSON.stringify(ownerList))
  useEffect(() => {
    if (ownerList && prevOwnerList !== JSON.stringify(ownerList) && type !== "owner") {

      if (ownerList.phone?.length !== 0) {
        setChangeMenuPhones(ownerList.phones.map(contact => (<MenuItem key={contact.id}
                                                                       onClick={() => handleClosePhones(type, contact.id)}>{contact.phone}</MenuItem>)))
      }
      if (ownerList.mails?.length !== 0) {
        setChangeMenuMails(ownerList.mails.map(contact => (<MenuItem key={contact.id}
                                                                     onClick={() => handleCloseMails(type, contact.id)}>{contact.email}</MenuItem>)
        ))
      }
    }

  }, [ownerList])


  const switchSubtitle = (type) => {
    switch (type) {
      case "owner": {
        if (paymentType === "percent") {
          return (<p className="subtitle">
            Знаком <b>" <FontAwesomeIcon icon={"check-circle"} className="text-success"/> "</b> отмечены
            телефоны
            и почты которые будут отправлены туристу после подтверждения бронирования
          </p>)
        }

        return (
          <p className="subtitle">
            Знаком <b>" <FontAwesomeIcon icon={"check-circle"} className="text-success"/> "</b> отмечены
            телефоны
            и почты которые будут отображаться в блоке контактов на странице Вашего объекта
          </p>
        )
      }
      case "notification": {
        return <p className="subtitle">
          На выбранные контакты будут отправляться уведомления о новых бронированиях
        </p>
      }
      case "accountant": {
        return <p className="subtitle">
          На выбранные контакты будут отправляться уведомления о новых счетах
        </p>
      }
    }
  }

  const buttons = themeButtons()
  return (
    <div className="col-12">
      <div className="card phones-block mb-5 p-0 mx-auto">
        <div className="card-body ">
          <h5 className="card-title">{title}</h5>

          {switchSubtitle(type)}


          {lists && Object.keys(lists).map((key, i) => {
            return <div key={key + i} className="contact-block">
              {key === "phones"
                ? <div className="contacts-list ">
                  {lists && lists[key].map((contact, index) => (
                    <RenderPhoneListItem
                      key={contact.id}
                      ownerList={ownerList && ownerList[key]}
                      showChangeModal={() => {
                        toggleShow("modalEditPhone", type, contact.id)
                      }}
                      showDeleteModal={() => toggleShow("modalContactDelete", type, contact.id)}
                      owner={type === "owner"}
                      type={type}
                      phoneMain={contact.public}
                      replacementImportantContact={replacementImportantContact}
                      {...contact}/>
                  ))}
                </div>
                : <div className="contacts-list">
                  {lists && lists[key].map((contact, index) => (
                    <RenderMailListItem
                      key={contact.id}
                      ownerList={ownerList && ownerList[key]}
                      showChangeModal={() => {
                        toggleShow("modalEditMail", type, contact.id)
                      }}
                      showDeleteModal={() => toggleShow("modalContactDelete", type, contact.id)}
                      owner={type === "owner"}
                      type={type}
                      mailMain={contact.public}
                      replacementImportantContact={replacementImportantContact}
                      {...contact}/>
                  ))}
                </div>
              }


              {type === "owner" && <div className="contacts-list__actions">
                {key === "phones" && <Button className={`btn ${buttons.btnGreen}`}
                                             onClick={() => toggleShow("modalEditPhone")}>
                  <FontAwesomeIcon icon={"plus"} className="me-1"/> Добавить телефон
                </Button>}
                {key === "mails" && <Button className={`btn ${buttons.btnGreen}`}
                                            onClick={() => toggleShow("modalEditMail")}>
                  <FontAwesomeIcon icon={"plus"} className="me-1"/> Добавить почту
                </Button>}
              </div>}

              {type !== "owner" && lists[key].length === 0 &&
                <div className="contacts-list__actions d-flex align-items-center">

                  {key === "phones" && <><span>Телефон не указан</span>
                    {ownerList.phones.length === 0
                      ? <Button
                        className={`ms-auto btn ${buttons.btnGreen}`}
                        onClick={() => toggleShow("modalEditPhone", type)}>
                        <FontAwesomeIcon icon={"plus"} className="me-1"/> Добавить телефон
                      </Button>
                      : <>
                        <CustomTooltip
                          title={'Этот контакт можно заменить на любой из блока "Контакты объекта размещения"'}
                          arrow placement="top">
                                                <span className="ms-auto">
                                                    <Button className={`btn ${buttons.btnGreen}`}
                                                            onClick={handleClickPhones}>
                                                        Выбрать
                                                    </Button>
                                                </span>
                        </CustomTooltip>
                        <Menu
                          anchorEl={anchorElPhones}
                          open={Boolean(anchorElPhones)}
                          onClose={() => handleClosePhones()}
                          getContentAnchorEl={null}
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                          }}
                          transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                          }}
                        >
                          {changeMenuPhones}


                        </Menu>
                      </>}


                  </>}

                  {key === "mails" && <><span>Почта не указана</span>
                    {ownerList.mails.length === 0
                      ? <Button
                        className={`ms-auto btn ${buttons.btnGreen}`}
                        onClick={() => toggleShow("modalEditMail", type)}>
                        <FontAwesomeIcon icon={"plus"} className="me-1"/> Добавить почту
                      </Button>
                      : <>
                        <CustomTooltip
                          title={'Этот контакт можно заменить на любой из блока "Контакты объекта размещения"'}
                          arrow placement="top">
                                                <span className="ms-auto">
                                                    <Button className={`btn ${buttons.btnGreen}`}
                                                            onClick={handleClickMails}>
                                                        Выбрать
                                                    </Button>
                                                </span>
                        </CustomTooltip>
                        <Menu
                          anchorEl={anchorElMails}
                          open={Boolean(anchorElMails)}
                          onClose={() => handleCloseMails()}
                          getContentAnchorEl={null}
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                          }}
                          transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                          }}
                        >
                          {changeMenuMails}


                        </Menu>
                      </>

                    }
                  </>
                  }

                </div>}

            </div>
          })}
        </div>
      </div>
    </div>
  )
}

//контроль наличия контактов для публикации
export const HasPublicContactControl = ({ setHasPublicContact, ownerList }) => {
  useEffect(() => {
    let contactsHasPublic = ownerList.filter(contact => contact.public === "Y")

    if (contactsHasPublic.length === 1) {
      setHasPublicContact(true)
    }

  }, [])


  return <></>
}


//модалка добавления телефона
export const RenderModalEditPhone = ({
  show,
  toggleShow,
  editContact,
  addNewContact,
  removedContact,
  ownerList,
  setEditContact,
  setRemovedContact,
  paymentType
}) => {
  const [hasPublicContact, setHasPublicContact] = useState(false)


  const contactSchema = Yup.object().shape({
    name: Yup.string()
      .min(3, 'Слишком короткое имя')
      .max(50, 'Слишком длинное имя'),
    phone: Yup.string()
      .min(11, 'Введите корректный номер телефона (пример: +79999999999)')
      .max(25, 'Введите корректный номер телефона (пример: +79999999999)')
      .matches(phoneRegExp, 'Введите корректный номер телефона (пример: +79999999999)')
      .required("Поле телефон не может быть пустым"),
  }, [['phone']]);


  const [initValue, setInitValue] = useState({ phone: '' })

  useEffect(() => {

    if (ownerList.length === 0) {
      let newInitValue = {
        notification: true,
        accountant: true,
      }

      setInitValue(newInitValue)
    }

    if (editContact) {
      let newInitValue = {}

      newInitValue = {
        ...newInitValue,
        id: editContact.id ? editContact.id : '',
        phone: editContact.phone ? editContact.phone : '',
        public: editContact.public === "Y",
        WA: editContact.messenger && editContact.messenger.indexOf("WHATSAPP") !== -1,
        VB: editContact.messenger && editContact.messenger.indexOf("VIBER") !== -1,
        name: editContact.name ? editContact.name : '',
        position: editContact.position ? editContact.position : '',
        notification: editContact.notification === "Y",
        accountant: editContact.accountant === "Y",
      }
      setInitValue(newInitValue)

    }
    if (removedContact) {
      let newInitValue = {}

      newInitValue = {
        ...newInitValue,
        notification: removedContact.notification === "Y",
        accountant: removedContact.accountant === "Y",
        public: removedContact.public === "Y",
      }

      setInitValue(newInitValue)

    }

  }, [])

  const onSubmit = (values) => {
    addNewContact(values)
    toggleShow("modalAddPhone")
  }

  const closeImportantContactChange = () => {
    setEditContact(null)
    setRemovedContact(null)
    toggleShow()
  }


  return (
    <Formik initialValues={initValue}
            onSubmit={onSubmit}
            validationSchema={contactSchema}
            enableReinitialize>
      {({ handleSubmit, values, errors, touched }) => (
        <Modal toggleShow={toggleShow} show={show}
               title={editContact && editContact.id ? "Изменение контакта:" : "Добавление контакта:"}
               textBtnOk={editContact && editContact.id ? "Изменить" : "Добавить"}
               btnOkAction={handleSubmit}
               btnCancelAction={closeImportantContactChange}>

          <Form onSubmit={handleSubmit}>
            {ownerList && editContact &&
              <HasPublicContactControl ownerList={ownerList} setHasPublicContact={setHasPublicContact}/>}
            <div className="row">
              <div className={`col-12 ${ownerList.length !== 0 ? "mb-1" : "mb-3"}`}>
                <Field name="phone">
                  {({ field, form }) => (
                    <TextField
                      {...field}
                      label="Телефон"
                      fullWidth
                      size="small"
                      variant="outlined"
                      error={Boolean(errors.phone && touched.phone)}
                      helperText={touched.phone && errors.phone}
                    />
                  )}
                </Field>
              </div>
              <div className="row mb-3">
                <div className="col-md-6 d-flex">
                  <Field type="checkbox" name="public">
                    {({ field }) => (
                      <FormControl
                        label="Телефон для публикации"
                        disabled={hasPublicContact && editContact?.public === "Y"}
                        className="me-3"
                        control={<GreenCheckbox {...field} />}
                      />
                    )}
                  </Field>
                </div>

                <div className="col-md-3 d-flex">
                  <Field type="checkbox" name="WA">
                    {({ field }) => (
                      <FormControl
                        label="WhatsApp"
                        className="me-3"
                        control={<GreenCheckbox {...field} />}
                      />
                    )}
                  </Field>
                </div>
                <div className="col-md-3 d-flex">
                  <Field type="checkbox" name="VB">
                    {({ field }) => (
                      <FormControl
                        label="Viber"
                        control={<GreenCheckbox {...field} />}
                      />
                    )}
                  </Field>
                </div>
                {ownerList.length === 0
                  ? <>
                    <div className="col-md-6 d-flex">
                      <Field type="checkbox" name="notification">
                        {({ field }) => (
                          <FormControl
                            disabled={true}
                            label="Телефон для уведомлений"
                            control={<GreenCheckbox {...field} />}
                          />
                        )}
                      </Field>
                    </div>
                    <div className="col-md-6 d-flex">
                      <Field type="checkbox" name="accountant">
                        {({ field }) => (
                          <FormControl
                            disabled={true}
                            label="Телефон бухгалтерии"
                            control={<GreenCheckbox {...field} />}
                          />
                        )}
                      </Field>
                    </div>
                  </>
                  : <></>}

              </div>

              <div className="col-12  mb-3">
                <Field name="name">
                  {({ field, form }) => (
                    <TextField
                      {...field}
                      label="Имя"
                      fullWidth
                      size="small"
                      variant="outlined"
                      error={Boolean(errors.name && touched.name)}
                      helperText={touched.name && errors.name}
                    />
                  )}
                </Field>

              </div>
              <div className="col-12  mb-3">
                <Field name="position">
                  {({ field, form }) => (
                    <TextField
                      {...field}
                      label="Должность"
                      fullWidth
                      size="small"
                      variant="outlined"
                      inputProps={{ maxLength: 35 }}
                      helperText={`${field.value?.length ? field.value?.length : 0}/35`}
                    />
                  )}
                </Field>

              </div>
            </div>
          </Form>
        </Modal>
      )}
    </Formik>
  )
}

//модалка добавления почты
export const RenderModalEditMail = ({
  show,
  toggleShow,
  editContact,
  addNewContact,
  removedContact,
  ownerList,
  setEditContact,
  setRemovedContact,
  paymentType
}) => {
  const [hasPublicContact, setHasPublicContact] = useState(false)

  useEffect(() => {
    if (ownerList && editContact && paymentType === "subscriber") {
      let contactsHasPublic = ownerList.filter(contact => contact.public === "Y")
      if (contactsHasPublic.length === 1) {
        setHasPublicContact(true)
      }
    }
  }, [])


  const contactSchema = Yup.object().shape({
    'email': Yup.string()
      .email('Некорректный Email')
      .required("Поле почта не может быть пустым"),
  }, [['email']]);

  const [initValue, setInitValue] = useState({ email: '' })

  useEffect(() => {
    if (ownerList.length === 0) {
      let newInitValue = {
        notification: true,
        accountant: true,
      }

      setInitValue(newInitValue)
    }


    if (editContact) {
      let newInitValue = {}

      newInitValue = {
        ...newInitValue,
        id: editContact.id ? editContact.id : '',
        email: editContact.email ? editContact.email : '',
        position: editContact.position ? editContact.position : '',
        public: editContact.public === "Y",
        notification: editContact.notification === "Y",
        accountant: editContact.accountant === "Y",
      }

      setInitValue(newInitValue)
    }
    if (removedContact) {
      let newInitValue = {}

      newInitValue = {
        ...newInitValue,
        notification: removedContact.notification === "Y",
        accountant: removedContact.accountant === "Y",
        public: removedContact.public === "Y",
      }

      setInitValue(newInitValue)

    }
  }, [])


  const onSubmit = (values) => {
    addNewContact(values)
    toggleShow("modalAddMail")
  }

  const closeImportantContactChange = () => {
    setEditContact(null)
    setRemovedContact(null)
    toggleShow()
  }


  return (
    <Formik initialValues={initValue}
            onSubmit={onSubmit}
            enableReinitialize
            validationSchema={contactSchema}>
      {({ handleSubmit, values }) => (
        <Modal toggleShow={toggleShow} show={show}
               title={editContact && editContact.id ? "Изменение контакта:" : "Добавление контакта:"}
               textBtnOk={editContact && editContact.id ? "Изменить" : "Добавить"}
               btnOkAction={handleSubmit}
               btnCancelAction={closeImportantContactChange}>
          <Form onSubmit={handleSubmit}>
            {ownerList && editContact &&
              <HasPublicContactControl ownerList={ownerList} setHasPublicContact={setHasPublicContact}/>}
            <div className="row">
              <div className="col-12 mb-1">
                <Field name="email">
                  {({ field, form }) => (
                    <TextField
                      {...field}
                      label="Email"
                      fullWidth
                      size="small"
                      variant="outlined"
                      error={Boolean(form.errors.email && form.touched.email)}
                      helperText={
                        form.errors.email &&
                        form.touched.email &&
                        String(form.errors.email)
                      }
                    />
                  )}
                </Field>

              </div>

              <div className="col-md-6 d-flex">
                <Field type="checkbox" name="public">
                  {({ field }) => (
                    <FormControl
                      disabled={hasPublicContact && editContact?.public === "Y"}
                      label="Почта для публикации"
                      control={<GreenCheckbox {...field} />}
                    />
                  )}
                </Field>
              </div>
              {ownerList.length !== 0
                ? <></>
                : <>
                  <div className="col-md-6 d-flex">
                    <Field type="checkbox" name="notification">
                      {({ field }) => (
                        <FormControl
                          disabled={true}
                          label="Почта для уведомлений"
                          control={<GreenCheckbox {...field} />}
                        />
                      )}
                    </Field>
                  </div>
                  <div className="col-md-6 d-flex">
                    <Field type="checkbox" name="accountant">
                      {({ field }) => (
                        <FormControl
                          disabled={true}
                          label="Почта бухгалтерии"
                          control={<GreenCheckbox {...field} />}
                        />
                      )}
                    </Field>
                  </div>
                </>
              }
              <div className="col-12 mt-3 mb-3">
                <Field name="position">
                  {({ field, form }) => (
                    <TextField
                      {...field}
                      label="Должность"
                      fullWidth
                      size="small"
                      variant="outlined"
                      inputProps={{ maxLength: 35 }}
                      helperText={`${field.value?.length ? field.value?.length : 0}/35`}
                    />
                  )}
                </Field>

              </div>


            </div>

          </Form>
        </Modal>
      )}
    </Formik>
  )
}

//модалка удаления контакта
export const RenderModalContactDelete = ({ show, toggleShow, editContact, deleteContact }) => {

  const deletePhone = () => {
    if (editContact.notification === "Y" || editContact.accountant === "Y" || editContact.public === "Y") {
      deleteContact(editContact.phone ? "phone" : "mail")
    } else {
      deleteContact()
    }
  }

  const warningText = () => {


    if (editContact.notification === "Y" && editContact.accountant === "Y" && editContact.public === "Y") {
      return "Контакт используется для уведомлении о бронированиях и бухгалтерии, а так же для отображения на странице объекта"
    }

    if (editContact.notification === "Y" && editContact.accountant === "Y") {
      return "Контакт используется для уведомлении о бронированиях и бухгалтерии"
    }
    if (editContact.notification === "Y" && editContact.public === "Y") {
      return "Контакт используется для уведомлении о бронированиях и для отображения на странице объекта"
    }
    if (editContact.accountant === "Y" && editContact.public === "Y") {
      return "Контакт используется для уведомлении по бухгалтерии и для отображения на странице объекта"
    }

    if (editContact.notification === "Y") {
      return "Контакт используется для уведомлении о бронированиях"
    }
    if (editContact.accountant === "Y") {
      return "Контакт используется для уведомлении по бухгалтерии"
    }

    if (editContact.public === "Y") {
      return "Контакт используется для отображения на странице объекта"
    }

  }


  return (<Modal toggleShow={toggleShow} show={show}
                 title={"Удаление контакта:"}
                 textBtnOk={"Удалить"} btnOkAction={deletePhone}>

    <div className="col-sm-12 mb-1">
      <div>
        <p><b>{warningText()}</b></p>
        <p>Вы уверены, что хотите удалить
          контакт: <b>{editContact.phone ? editContact.phone : editContact.email}</b> ?
        </p>
      </div>

    </div>


  </Modal>)

}


export const RenderModalImportantContact = ({
  show,
  toggleShow,
  editContact,
  removeAndAddNew,
  lists,
  changeImportantContact
}) => {

  const [contactsList, setContactsList] = useState()

  useEffect(() => {
    if (!contactsList && editContact) {
      let newContactsList = {}


      if (editContact.phone) {
        lists.phones.map(item => {
          if (editContact.phone !== item.phone) {
            newContactsList = { ...newContactsList, [item.phone]: false }
          }
        })
      } else {
        lists.mails.map(item => {
          if (editContact.email !== item.email) {
            newContactsList = { ...newContactsList, [item.email]: false }
          }
        })
      }


      setContactsList(newContactsList)
    }
  }, [editContact])


  let block = editContact.phone ? "phones" : "mails"

  let importantType = []

  if (editContact.notification) {
    importantType.push("notification")
  }
  if (editContact.accountant) {
    importantType.push("accountant")
  }
  if (editContact.public) {
    importantType.push("public")
  }


  const onSubmit = (values) => {
    changeImportantContact(block, values.newImportant, importantType)
  }

  const deleteAndAddNew = () => {
    removeAndAddNew(editContact.phone ? "modalEditPhone" : "modalEditMail")
  }

  const modalTitle = () => {
    if (editContact.notification === "Y") {
      return "Выберите новый контакт для уведомлений:"
    }
    if (editContact.accountant === "Y") {
      return "Выберите новый контакт бухгалтерии:"
    }
    return "Выберите новый контакт для публикации:"
  }

  const buttons = themeButtons()
  return (
    <Formik initialValues={{ newImportant: '' }}
            onSubmit={onSubmit}
            enableReinitialize>
      {({ handleSubmit, values }) => (
        <Modal toggleShow={toggleShow}
               show={show}
               title={modalTitle}
               textBtnOk={"Выбрать"}
               btnOkAction={handleSubmit}
               disableBtnOk={values.newImportant.length === 0}
        >

          <div className="row">
            <div className="col-6">
              <Form>
                <div className="row">
                  <h6>Выбрать из имеющихся:</h6>
                  {contactsList && Object.keys(contactsList).map(item => {
                    return <div className="col-12" key={item}>
                      <Field type="radio" name={"newImportant"} value={item}>
                        {({ field }) => (
                          <FormControl
                            label={item}
                            control={<GreenRadio {...field} />}
                          />
                        )}
                      </Field>
                    </div>
                  })}
                </div>
              </Form>
            </div>
            <div className="col-6">
              <h6>Добавить новый:</h6>
              <Button onClick={deleteAndAddNew} className={`btn ${buttons.btnGreen}`}>
                <FontAwesomeIcon icon={"plus"} className="me-1"/> Добавить
              </Button>
            </div>
          </div>


        </Modal>
      )}
    </Formik>
  )
}


const ObjectContacts = (props) => {
  const { objectId, owner, accountant, notification, savePage, messengers, getMessengersList, paymentType } = props

  //изменяемый контакт
  const [editContact, setEditContact] = useState()

  //удаляемый контакт
  const [removedContact, setRemovedContact] = useState()

  //snackbar ошибка на клиентке
  const [savingErrorMessage, setSavingErrorMessage] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false)
  }


  //состояние модалок, по дефолту скрыты
  let [show, toggleModalShow] = useState({
    modalEditPhone: false,
    modalEditMail: false,
    modalContactDelete: false,
    modalImportantContact: false,
  });

  useEffect(() => {
    if (!messengers) {
      getMessengersList()
    }
  }, [])


  //открытие/закрытие модалок
  const toggleShow = (modalName, type, contactId) => {

    switch (type) {
      case "notification":
        setEditContact(Object.values(notification).flat().filter(item => item.id == contactId)[0])
        break
      case "accountant":
        setEditContact(Object.values(accountant).flat().filter(item => item.id == contactId)[0])
        break
      default:
        setEditContact(Object.values(owner).flat().filter(item => item.id == contactId)[0])
    }


    toggleModalShow({ ...show, [modalName]: !show[modalName] })
  };


  //добавление контакта
  const addNewContact = async (value) => {

    let savedContact = value
    const block = value.phone ? "phones" : "mails"
    const key = value.phone ? "phone" : "email"

    let contactToRemove = {}

    let equalContact = null

    if (key === "phone") {
      equalContact = [...owner[block]].find(item => item[key].replace(/[^\d]/g, '') === value[key].replace(/[^\d]/g, ''))
    } else {
      equalContact = [...owner[block]].find(item => item[key] === value[key])
    }

    if (equalContact && !editContact) {
      setOpenSnackbar(true)
      setSavingErrorMessage("Такой контакт уже добавлен")

      return
    }

    let copyContacts = [...owner[block]].filter(item => item.id !== removedContact?.id && item[key] !== value[key])


    if (removedContact) {
      contactToRemove = { id: removedContact.id, [key]: "" }
    }


    if (key === "phone") {
      let messenger = [value.WA && "WHATSAPP", value.VB && "VIBER"]
      delete savedContact["WA"]
      delete savedContact["VB"]

      savedContact = { ...savedContact, messenger: messenger }
    }

    savedContact = {
      ...savedContact,
      public: savedContact.public ? "Y" : "N",
      accountant: savedContact.accountant ? "Y" : "N",
      notification: savedContact.notification ? "Y" : "N"
    }


    let data = { ...owner, [block]: [...copyContacts, savedContact] }

    if (Object.keys(contactToRemove).length !== 0) {
      data[block].push(contactToRemove)
    }

    await savePage({ object: objectId, section: "contact", data: data })

    setRemovedContact("")

  }

  //удаление старого контакта с заменой на новый
  const removeAndAddNew = (modal) => {

    toggleModalShow((prev) => {
      return {
        ...prev,
        "modalImportantContact": !prev["modalImportantContact"],
        [modal]: !prev[modal]
      }
    })

    setRemovedContact(editContact)
    setEditContact(null)
  }

  //удаление старого контакта с заменой на имеющийся в списке
  const changeImportantContact = (block, contact, importantType) => {


    const itemKey = block === "phones" ? "phone" : "email"

    let removedContact = { id: editContact.id, [itemKey]: '' }
    let changedContact = owner[block].find(item => item[itemKey] === contact)
    let savedContact = owner[block].filter(item => item[itemKey] !== contact && editContact.id !== item.id)

    importantType.map(important => changedContact[important] = "Y")
    savedContact.push(removedContact)
    savedContact.push(changedContact)

    let data = { ...owner, [block]: savedContact }
    savePage({ object: objectId, section: "contact", data: data })


    toggleModalShow((prev) => {
      return {
        ...prev,
        "modalImportantContact": !prev["modalImportantContact"]
      }
    })

  }

  //удаление контакта
  const deleteContact = (contactType) => {

    if (!contactType) {

      let contactToRemove = {}
      if (editContact.phone) {

        contactToRemove = [{ id: editContact.id, phone: "" }]
        let data = {
          ...owner,
          phones: [...owner.phones.filter(item => item.id !== editContact.id), ...contactToRemove]
        }

        savePage({ object: objectId, section: "contact", data: data })

      } else {
        contactToRemove = [{ id: editContact.id, email: "" }]
        let data = {
          ...owner,
          mails: [...owner.phones.filter(item => item.id !== editContact.id), ...contactToRemove]
        }

        savePage({ object: objectId, section: "contact", data: data })
      }

      setEditContact(null)
      toggleModalShow((prev) => {
        return { ...prev, "modalContactDelete": !prev["modalContactDelete"] }
      })
    } else {
      toggleModalShow((prev) => {
        return {
          ...prev,
          "modalContactDelete": !prev["modalContactDelete"],
          "modalImportantContact": !prev["modalImportantContact"]
        }
      })
    }

  }


  const replacementImportantContact = (type, block, newImportantId, oldImportantId) => {

    if (!newImportantId || !type) {
      return
    }

    let updaterContacts = owner[block].map(item => {
      if (item.id == newImportantId) {
        return { ...item, [type]: "Y" }
      }
      if (item.id == oldImportantId) {
        return { ...item, [type]: "N" }
      }
      return item
    })


    let formData = {}
    if (block === "phones") {
      formData = { ...owner, phones: updaterContacts }
    }
    if (block === "mails") {
      formData = { ...owner, mails: updaterContacts }
    }


    savePage({ object: objectId, section: "contact", data: formData })


  }

  const classes = useStyles();
  if (!owner) {
    return <Preloader loading={true}/>
  }

  return (
    <div className="main edit-object">
      <div className="container-fluid">
        <RenderPhoneBlock type={"owner"}
                          title={"Контакты объекта размещения"}
                          lists={owner}
                          ownerList={owner}
                          messengers={messengers}
                          toggleShow={toggleShow}
                          paymentType={paymentType}
                          replacementImportantContact={replacementImportantContact}/>

        <RenderPhoneBlock type={"notification"}
                          title={"Контакты для уведомлений"}
                          lists={notification}

                          ownerList={owner}
                          messengers={messengers}
                          toggleShow={toggleShow}
                          replacementImportantContact={replacementImportantContact}/>

        <RenderPhoneBlock type={"accountant"}
                          title={"Контакты бухгалтерии"}
                          lists={accountant}

                          ownerList={owner}
                          messengers={messengers}
                          toggleShow={toggleShow}
                          replacementImportantContact={replacementImportantContact}/>


        {show.modalEditPhone && <RenderModalEditPhone toggleShow={() => toggleShow("modalEditPhone")}
                                                      show={show.modalEditPhone}
                                                      ownerList={owner.phones}

                                                      editContact={editContact}
                                                      removedContact={removedContact}
                                                      paymentType={paymentType}
                                                      setEditContact={setEditContact}
                                                      setRemovedContact={setRemovedContact}
                                                      addNewContact={addNewContact}/>}

        {show.modalEditMail && <RenderModalEditMail toggleShow={() => toggleShow("modalEditMail")}
                                                    show={show.modalEditMail}
                                                    ownerList={owner.mails}

                                                    editContact={editContact}
                                                    removedContact={removedContact}
                                                    paymentType={paymentType}
                                                    setEditContact={setEditContact}
                                                    setRemovedContact={setRemovedContact}
                                                    addNewContact={addNewContact}/>}


        {show.modalContactDelete && editContact &&
          <RenderModalContactDelete toggleShow={() => toggleShow("modalContactDelete")}
                                    show={show.modalContactDelete}
                                    editContact={editContact}
                                    deleteContact={deleteContact}/>}


        {show.modalImportantContact && editContact &&
          <RenderModalImportantContact toggleShow={() => toggleShow("modalImportantContact")}
                                       show={show.modalImportantContact}
                                       editContact={editContact}
                                       lists={owner}
                                       removeAndAddNew={removeAndAddNew}
                                       changeImportantContact={changeImportantContact}/>}

        <Snackbar open={openSnackbar} className={classes.snackbar} autoHideDuration={2000}
                  onClose={handleCloseSnackbar}>
          <Alert severity="error">
            {savingErrorMessage ? savingErrorMessage : "Ошибка"}
          </Alert>
        </Snackbar>
      </div>

      <FunctionSidebarContainer/>
    </div>
  )
}


export default ObjectContacts;
